// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PAvQ","field":"styles_field__3gSYG","fieldCol":"styles_fieldCol__3ErsX","diffCol":"styles_diffCol__1ClDj","diff":"styles_diff__3LE7e"};